<h2>Select options</h2>

<div class="flex justify-content-center">
  <div class="flex flex-column gap-1">
    @for (item of items(); track item.SkuPk) {
      <strong>{{item.subDescription}}</strong>
    <div class="flex flex-row flex-wrap spacer gap-3">
      <div class="flex align-items-center justify-content-center input">
        <p-inputNumber [showButtons]="true"
                       [min]="0"
                       [max]="item.max"
                       [(ngModel)]="item.cartQty"
                       buttonLayout="horizontal"
                       inputId="horizontal"
                       spinnerMode="horizontal"
                       incrementButtonIcon="pi pi-plus"
                       decrementButtonIcon="pi pi-minus"
                       [disabled]="isRsoItem(item)" />
      </div>
      <div class="flex align-items-center justify-content-center">
        {{item.Description}} ({{item.Price === 0 ? 'No Charge' : item.Price | currency}})
      </div>
    </div>
    }
  </div>
</div>
<div class="flex justify-content-between mt-1 w-full">
  <p-button [routerLink]="['../', routes.ADD_ONS]" label="BACK"></p-button>
  <p-button (click)="onNextClick()" label="NEXT"></p-button>
</div>